<app-navbar></app-navbar>
<div
  class="admin-content-shell flex min-h-0 flex-col md:flex-row"
  [style.height]="'calc(100dvh - ' + navHeight + 'px)'"
  [style.--admin-nav-height.px]="navHeight"
>
  <aside
          appToggleHover
          style="transition: width 0.3s ease-in-out"
          class="group bg-white flex-none min-w-0 z-10
          hidden md:block md:border-r md:border-grayLight
          md:shadow-[6px_0_16px_-8px_rgba(15,23,42,0.12)]"
          [ngClass]="(sidebarState.shrunk$ | async) ? 'w-16' : 'w-sidebar'">
    <app-sidebar></app-sidebar>
  </aside>
  <!-- cdkScrollable registers this element with the CDK ScrollDispatcher, which is
       what overlay panels (mat-autocomplete, mat-select) listen to in order to
       follow their field. Without it the CDK only hears document-level scrolling,
       so a dropdown opened on this page stayed put while the form scrolled away
       underneath it (BRIEFD-7094). -->
  <div class="min-h-0 min-w-0 flex-1 overflow-auto" style="background: #F5F5F5" #pageWindow cdkScrollable>
    <app-version-toggle-banner
      [accountFlag]="AccountFeaturesEnum.FEATURE_FLAG_AB_REDESIGN_V2"
      prefKey="useAbRedesignV2Pref"
      [migratedRoutes]="abMigratedRoutes"
    />
    <router-outlet></router-outlet>
  </div>

  <app-chat-bot></app-chat-bot>
  <app-notification-popup
          class="app-notification-popup-wrapper"
          [notifications$]="loudNotifications$"></app-notification-popup>
</div>
